/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */

import { Pagination } from '../models/Pagination';
import { PulumiConfiguration } from '../models/PulumiConfiguration';

export class PulumiConfigurations {
  'pulumiConfigurations'?: Array<PulumiConfiguration>;
  'pagination'?: Pagination;

  static readonly discriminator: string | undefined = undefined;

  static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
    {
      "name": "pulumiConfigurations",
      "baseName": "pulumiConfigurations",
      "type": "Array<PulumiConfiguration>",
      "format": ""
    },
    {
      "name": "pagination",
      "baseName": "pagination",
      "type": "Pagination",
      "format": ""
    }  ];

  static getAttributeTypeMap() {
    return PulumiConfigurations.attributeTypeMap;
  }

  public constructor() {
  }
}

